var Module = /** @class */ (function () {
    function Module(name, dependencies) {
        this.name = name;
        this.dependencies = dependencies;
    }
    Module.prototype.fail = function (reason) {
        console.log("Module '" + this.name + "' failed to load: " + reason);
        throw new Error(reason);
    };
    Module.prototype.warn = function (msg) {
        console.log("Module " + this.name + ": " + msg);
    };
    Module.prototype.createError = function (msg) {
        return new Error("Error in Rangy " + this.name + " module: " + msg);
    };
    return Module;
}());
export { Module };
//# sourceMappingURL=module.js.map